import * as React from 'react';
import {MenuItemContainer} from '../../../../system/menu';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Action, Secondary} from '../../../../system/buttons';
import Toggle from 'react-toggle';
import {Link} from 'react-router-dom';
import PulsoidClient from '../../../../PulsoidClient';
import {MessageAlert, resolveFeatureDescription} from '../../utils';
import {LoaderWrapper} from '../../../../system/Loader/Loader';
import {PremiumWrapper} from '../../../PremiumWrapper';
import {resolveWebHookEdit} from './mapping';
import {DASHBOARD_ROUTES} from '../../../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../../../navigation/navigationUtils';
import {HeadTitle} from '../../../../system/HeadTitle';

export class WebHookEditContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.client = new PulsoidClient();
    this.state = {
      isChanged: false,
      loading: false,
      performingTestWebHook: false,
      isStatusToggleDisabled: true,
    };
  }

  initWebHook = () =>
    this.client
      .getWebHook(this.props.match.params.id)
      .then((res) => this.setState({isChanged: false, ...res}));

  componentDidMount() {
    this.initWebHook();
  }

  render() {
    if (!!!this.state.status || this.state.loading) {
      return (
        <MenuItemContainer title={'Integrations'}>
          <LoaderWrapper loading={true} />
        </MenuItemContainer>
      );
    }
    return (
      <MenuItemContainer title={'Integrations'}>
        <HeadTitle title={this.state.description} />
        <h3>
          <Link to={buildRoute({path: DASHBOARD_ROUTES.INTEGRATIONS})}>
            Integrations
          </Link>
          {` > ${this.state.name}`}
        </h3>
        <div className={'text-muted'}>
          {this.state.description}{' '}
          {resolveFeatureDescription(this.state.metaId)}
        </div>
        <hr />
        <PremiumWrapper
          bi={{
            from: 'web_hook_integration',
            id: this.props.match.params.id,
          }}
          onPremiumChange={(isPremium) =>
            this.setState({isStatusToggleDisabled: !isPremium})
          }
        >
          <></>
        </PremiumWrapper>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Status: {this.state.status}
          </Form.Label>
          <Col sm="auto" className={'align-vertical-center'}>
            <Toggle
              disabled={this.state.isStatusToggleDisabled}
              checked={this.state.status === 'Enabled'}
              onChange={async (e) => {
                this.setState({loading: true});
                if (this.state.validateAndGet()) {
                  if (!this.state.isChanged) {
                    await this.client.changeWebHookStatus(
                      this.props.match.params.id,
                      e.target.checked ? 'Enabled' : 'Disabled'
                    );
                    await this.client
                      .getWebHook(this.props.match.params.id)
                      .then((res) => this.setState({...res}));
                  } else {
                    alert('Save changes before changing status.');
                  }
                } else {
                }

                this.setState({loading: false});
              }}
            />
          </Col>
          <Col>
            <Secondary
              disabled={
                this.state.status !== 'Enabled' ||
                this.state.performingTestWebHook
              }
              onClick={async () => {
                if (!this.state.isChanged) {
                  this.setState({performingTestWebHook: true});
                  let bpm = parseInt(prompt('Enter bpm value'));
                  if (isNaN(bpm)) {
                    alert('Not a number');
                  } else {
                    let result = await this.client.executeTestWebHook(
                      this.state.id,
                      bpm
                    );
                    if (result.success) {
                      alert('Successfully execute!');
                    } else {
                      if (result.details) {
                        alert(`Failed to execute ${result.details}`);
                      } else {
                        alert(`Failed to execute`);
                      }
                    }
                  }
                  this.setState({performingTestWebHook: false});
                } else {
                  alert('Save changes before changing firing tes webhook.');
                }
              }}
            >
              Fire test webhook
            </Secondary>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Trigger heart rate
          </Form.Label>
          <Col sm="3">
            <Form.Control
              as="input"
              type={'number'}
              value={this.state.triggerBpm}
              onChange={(e) => {
                if (!isNaN(+e.target.value)) {
                  this.setState({
                    triggerBpm: +e.target.value,
                    triggerBpmError: undefined,
                    isChanged: true,
                  });
                }
              }}
              max={'300'}
              min={'1'}
            />
          </Col>
        </Form.Group>
        <MessageAlert message={this.state.triggerBpmError} />

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Trigger window (minutes)
          </Form.Label>
          <Col sm="3">
            <Form.Control
              as="input"
              type={'text'}
              pattern="\d*"
              value={this.state.triggerWindow}
              onChange={(e) => {
                if (
                  (!isNaN(+e.target.value) && +e.target.value > 0) ||
                  e.target.value === ''
                ) {
                  this.setState({
                    triggerWindow: +e.target.value,
                    triggerWindowError: undefined,
                    isChanged: true,
                  });
                }
              }}
            />
          </Col>
        </Form.Group>
        <MessageAlert message={this.state.triggerWindowError} />

        {resolveWebHookEdit(
          this.state.metaId,
          this.state.configuration,
          (configuration) => this.setState({configuration, isChanged: true}),
          (validateAndGet) => this.setState({validateAndGet})
        )}

        <Row>
          <Col md="auto">
            <Action
              onClick={async () => {
                this.setState({loading: true});
                let isValid = true;
                if (this.state.triggerWindow <= 0) {
                  this.setState({
                    triggerWindowError:
                      'Trigger window should be higher than 0.',
                  });
                  isValid = false;
                } else if (this.state.triggerWindow >= 1000) {
                  this.setState({
                    triggerWindowError:
                      'Trigger window should be less than 1000.',
                  });
                  isValid = false;
                }

                if (this.state.triggerBpm <= 0) {
                  this.setState({
                    triggerBpmError: 'Trigger bpm should be higher than 0.',
                  });
                  isValid = false;
                } else if (this.state.triggerBpmError >= 300) {
                  this.setState({
                    triggerBpmError: 'Trigger window should be less than 300.',
                  });
                  isValid = false;
                }

                let isValidConfig = this.state.validateAndGet();
                isValid = isValid && isValidConfig;

                if (isValid) {
                  await this.client.updateWebHook(
                    this.props.match.params.id,
                    this.state.triggerBpm,
                    this.state.triggerWindow,
                    this.state.configuration
                  );
                  await this.initWebHook();
                }
                this.setState({loading: false});
              }}
            >
              Save
            </Action>
          </Col>
          <Col md="auto"></Col>
        </Row>
      </MenuItemContainer>
    );
  }
}
